import { useAuth as useAuthContext } from '../contexts/AuthContext'

export type { AuthUser as User } from '../types/Auth.types'

export interface UseAuthResult {
	user: { id: string; email: string; name: string } | null
	loading: boolean
	logout: () => void
}

/**
 * Hook to access authentication state.
 * Delegates to AuthContext which already manages session checking.
 * Does NOT make redundant /api/auth/me calls -- relies on AuthContext's
 * single session check on app mount.
 */
export function useAuth(): UseAuthResult {
	const { user, isLoading, logout } = useAuthContext()

	return {
		user,
		loading: isLoading,
		logout,
	}
}
